import { render, staticRenderFns } from "./CollectionAssetUploadWrapper.vue?vue&type=template&id=14a0710c&scoped=true"
import script from "./CollectionAssetUploadWrapper.vue?vue&type=script&lang=js"
export * from "./CollectionAssetUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a0710c",
  null
  
)

export default component.exports